(function ($) {
  "use strict";
  $(document).ready(function () {
    accordion.initAccordion();
  });
})(jQuery);

export var accordion = (function () {
  var initAccordion = function () {
    const hashTarget = location.hash
      ? $(`${location.hash}, [name="${location.hash.slice(1)}"]`)
      : false;

    const accordionContainingHashTarget = $(hashTarget)
      .closest(".accordion")
      .first();

    // Collapse accordions since JS enabled
    $(".accordion")
      .not(".open")
      .each(function () {
        closeAccordion($(this));
      });

    // Open accordion containing the target of the URL hash
    $(accordionContainingHashTarget).each(function () {
      openAccordion($(this));
    });

    // Filter accordions should be open by default
    $(".accordion.form-filters").each(function () {
      openAccordion($(this));
    });

    $(".accordion-toggle").unbind("click");
    // bind toggle to heading anchor
    $(".accordion-toggle").on("click", function (e) {
      e.preventDefault();

      var accordion = $(this).closest(".accordion");

      if (accordion.hasClass("open")) {
        closeAccordion(accordion);
      } else {
        openAccordion(accordion);
      }

      refreshToggleAllControl(accordion.data("accordionGroupControl"));
    });

    initToggleAllControls();

    // Scroll to targeted accordion on page load
    if (window.location.hash) {
      var hashPath = window.location.hash.replace("#", "");
      const $hashTarget = $(`[name="${hashPath}"]`);
      // open the relevent accordion base on the hash ID
      if ($hashTarget.length) {
        var $parentAccordion = $hashTarget.closest(".accordion");
        if ($parentAccordion.length) {
          $("html, body").prop({ scrollTop: 0 });
          scrollToOpenedAccordion($parentAccordion);
        }
      }
    }
  };

  // Accordions presenting page content. Search filters (`.form-filters`) and
  // search result blobs (`.no-border`) are deliberately left alone.
  var CONTENT_ACCORDION = ".accordion:not(.form-filters):not(.no-border)";

  var EXPAND_ALL_LABEL = "Expand all";
  var COLLAPSE_ALL_LABEL = "Collapse all";

  // Mirrors Includes/AccordionToggleIcon.ss so JS-built controls use currentColor.
  var ACCORDION_TOGGLE_ICON_HTML =
    '<svg class="accordion-toggle__icon accordion-toggle__icon--plus" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<rect x="18" y="4" width="4" height="32" rx="2" fill="currentColor"/>' +
    '<rect x="4" y="18" width="32" height="4" rx="2" fill="currentColor"/>' +
    "</svg>" +
    '<svg class="accordion-toggle__icon accordion-toggle__icon--minus" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<rect x="4" y="18" width="32" height="4" rx="2" fill="currentColor"/>' +
    "</svg>";

  /**
   * A run of accordions the reader sees as one set. Elemental accordions each
   * sit in their own `.element` wrapper, so the block we compare for adjacency
   * is that wrapper rather than the `.accordion` itself.
   */
  var groupBlockFor = function (accordion) {
    var elementWrapper = accordion.closest(".element-accordion");

    if (!elementWrapper.length) {
      return accordion[0];
    }

    return elementWrapper.parent(".element")[0] || elementWrapper[0];
  };

  /**
   * Groups of adjacent content accordions, as an array of
   * `[{ block, accordion }, ...]` runs. Groups of one are dropped - a lone
   * accordion has nothing to expand "all" of.
   */
  var findAccordionGroups = function () {
    var items = [];
    var groups = [];

    $(CONTENT_ACCORDION).each(function () {
      var $accordion = $(this);
      var block = groupBlockFor($accordion);

      // Ignore accordions nested inside another accordion's content - the
      // outermost one already represents them.
      var isNested = items.some(function (item) {
        return item.block === block;
      });

      if (!isNested) {
        items.push({ block: block, accordion: this });
      }
    });

    items.forEach(function (item) {
      var group = groups[groups.length - 1];
      var previous = group && group[group.length - 1];

      if (previous && $(item.block).prev()[0] === previous.block) {
        group.push(item);
      } else {
        groups.push([item]);
      }
    });

    return groups.filter(function (group) {
      return group.length > 1;
    });
  };

  var buildToggleAllControl = function (accordions, isElemental) {
    var contentIds = accordions
      .map(function () {
        return $(this).children(".accordion-content").attr("id");
      })
      .get()
      .filter(Boolean);

    var $button = $("<button>", {
      type: "button",
      class: "accordion-toggle-all",
      "aria-expanded": "false",
      html:
        '<span class="accordion-toggle-all__label">' +
        EXPAND_ALL_LABEL +
        "</span>" +
        ACCORDION_TOGGLE_ICON_HTML,
    });

    if (contentIds.length) {
      $button.attr("aria-controls", contentIds.join(" "));
    }

    var $controls = $('<div class="accordion-controls"></div>').append($button);

    if (!isElemental) {
      return { $root: $controls, $button: $button };
    }

    // Mirror the elemental wrapper markup so the control lines up with the
    // accordion headings below it.
    var $root = $(
      '<div class="element element-accordion-controls">' +
        '<div class="element-wrapper"><div class="wrapper"></div></div>' +
        "</div>"
    );

    $root.find(".wrapper").append($controls);

    return { $root: $root, $button: $button };
  };

  var refreshToggleAllControl = function ($button) {
    if (!$button || !$button.length) {
      return;
    }

    var accordions = $button.data("accordions");
    var allOpen = accordions.filter(":not(.open)").length === 0;

    $button
      .attr("aria-expanded", allOpen ? "true" : "false")
      .find(".accordion-toggle-all__label")
      .text(allOpen ? COLLAPSE_ALL_LABEL : EXPAND_ALL_LABEL);
  };

  var initToggleAllControls = function () {
    $(".element-accordion-controls, .accordion-controls").remove();

    findAccordionGroups().forEach(function (group) {
      var $firstBlock = $(group[0].block);
      var accordions = $(
        group.map(function (item) {
          return item.accordion;
        })
      );

      var control = buildToggleAllControl(accordions, $firstBlock.is(".element"));

      control.$button.data("accordions", accordions);
      accordions.data("accordionGroupControl", control.$button);

      control.$root.insertBefore($firstBlock);

      control.$button.on("click", function () {
        var shouldOpen = accordions.filter(":not(.open)").length > 0;

        accordions.each(function () {
          if (shouldOpen) {
            openAccordion($(this));
          } else {
            closeAccordion($(this));
          }
        });

        refreshToggleAllControl(control.$button);
      });

      refreshToggleAllControl(control.$button);
    });
  };

  var closeAccordion = function (elem) {
    var accordionContent = elem.children(".accordion-content");
    var accordionBtn = elem.find("button.accordion-toggle");

    elem.removeClass("open");

    accordionContent.hide();

    accordionBtn.attr("aria-expanded", "false");
    accordionContent.attr("aria-expanded", "false");
  };

  var openAccordion = function (elem) {
    var accordionContent = elem.children(".accordion-content");
    var accordionBtn = elem.find("button.accordion-toggle");

    elem.addClass("open");

    accordionContent.show();

    accordionBtn.attr("aria-expanded", "true");
    accordionContent.attr("aria-expanded", "true");
  };

  var scrollToOpenedAccordion = function (elem) {
    $("html, body").animate(
      {
        // make sure the scroll include the sticky header height
        // if the sticky header was at it max height then assuming the header height will be 66 - fix height when scrolling start for header
        // else just get the current height header height
        scrollTop:
          elem.offset().top -
          ($("#sticky-header").outerHeight() === 145
            ? 66
            : $("#sticky-header").outerHeight()),
      },
      800,
      function () {
        elem.focus();

        // remove id attribute before location.hash to prevent page jump
        var tId = elem.attr("id");
        elem.attr("id", "");
        // add id attribute back
        elem.attr("id", tId);
      }
    );
  };

  return {
    initAccordion: initAccordion,
    closeAccordion: closeAccordion,
    openAccordion: openAccordion,
  };
})();
